<!--  -->
<template>
  <div>
    <div id="cont">
      <div class="cont">
        <div class="cont_l">
          <div class="cont_l_01">
            <div class="cont_l_02">
              <img :src="images.rc_03">
            </div>
            <div class="cont_l_03">
              <ul class="lit01">
                <li class="lit01_c">
                  <router-link to="/recruiten" class="lit01_b">{{text.recruit1}}</router-link>
                </li>
              </ul>
            </div>
            <div class="cont_l_04"></div>
          </div>
        </div>
        <div class="cont_r">
          <div class="cont_r_t">
            <div class="cont_r_t01">
              <span>{{text.profile3}}</span>
              <span>：</span>
              <span>{{text.profile4}}</span>
              <span>-</span>
              <span>{{text.recruit1}}</span>
            </div>
          </div>
          <div class="cont_r_b">
            <div id="rightdiv">
              <router-view></router-view>
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: {
        recruit1: "CAREER",
        product3: "Aluminum Coil/Aluminum Plate/Aluminum Foil/CanBody",
        product4: "Remelt Lead Ingot/Remelt Zinc Ingot"
      },
      images: {
        rc_03: require("../../../assets/img/en/rc_03.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/recruit/recruit.vue